import type { RedoAuthRpcClient } from "@redotech/redo-merchant-auth-rpc/client";
import { createRedoAuthRpcClient } from "@redotech/redo-merchant-auth-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoAuthRpcClientContext: Context<RedoAuthRpcClient | undefined> =
  createContext<RedoAuthRpcClient | undefined>(undefined);
RedoAuthRpcClientContext.displayName = "RedoAuthRpcClientContext";

export function RedoAuthRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoAuthRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoAuthRpcClient({
      baseURL: new URL(`${baseUrl}/auth-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoAuthRpcClientContext.Provider value={redoAuthRpcClient}>
      {children}
    </RedoAuthRpcClientContext.Provider>
  );
}
